export default function (theme) {
    return {
        MuiMenuItem: {
            root: {
                whiteSpace: 'normal',
                overflow: 'auto'
            },
        }
    };
}